module.exports = __webpack_public_path__ + "img/prev_h.ccafb03.png";